import { Field, useFormikContext } from 'formik'
import get from 'lodash-es/get'
import React, { useState } from 'react'

import { Input, Select } from '@fourthwall/components'

import { getWeightOptions } from '../../../utils/products'
import * as S from './styled'
import type { WeightInputProps } from './types'

export const WeightInput = ({
  weightName,
  unitName,
  size = 'large',
  weightWidth = 136,
  unitWidth = 80,
  disabled = false,
  displayError = false,
  onWeightValueChange,
  onUnitValueChange,
}: WeightInputProps) => {
  const [isWeightInputFocused, setIsWeightInputFocused] = useState(false)
  const [isUnitInputFocused, setIsUnitInputFocused] = useState(false)
  const { errors } = useFormikContext()
  const invalid = !!get(errors, weightName) || !!get(errors, unitName)

  return (
    <>
      <S.WeightWrapper
        $active={isWeightInputFocused}
        style={{ width: weightWidth }}
        data-testid="WeightInput.Weight"
      >
        <Field
          component={Input}
          name={weightName}
          label="Weight"
          type="number"
          min={0}
          hideSpinner
          size={size}
          displayError={displayError}
          invalid={invalid}
          disabled={disabled}
          onValueChange={onWeightValueChange}
          onFocus={!disabled ? () => setIsWeightInputFocused(true) : undefined}
          onBlur={() => setIsWeightInputFocused(false)}
        />
      </S.WeightWrapper>
      <S.UnitWrapper
        $active={isUnitInputFocused}
        style={{ width: unitWidth }}
        data-testid="WeightInput.Unit"
      >
        <Field
          component={Select}
          name={unitName}
          label="Unit"
          options={getWeightOptions()}
          size={size}
          displayError={displayError}
          invalid={invalid}
          disabled={disabled}
          onValueChange={onUnitValueChange}
          onFocus={!disabled ? () => setIsUnitInputFocused(true) : undefined}
          onBlur={() => setIsUnitInputFocused(false)}
        />
      </S.UnitWrapper>
    </>
  )
}
